import React, { ReactElement } from 'react';
import { useRouter } from 'next/router';
import { Text } from '@feast-it/ui/light';

import { PATHS } from '../../../../constants/paths';
import { ENQUIRY_BUTTON_CLICKED } from '../../../../constants/analytics';
import { trackEvent } from '../../../../modules/analytics';
import { getAbsoluteUrl } from '@/helpers/formatUrl';
import { SeoPageContent } from '../../../../types';
import { useIsDarkTheme } from '../../../../context/DarkThemeContext';
import {
  Container,
  SuppliersTitle,
  EnquireLink,
} from './SuppliersHeader.styled';

interface SuppliersHeaderProps {
  pageContent: SeoPageContent;
  amountOfSuppliers: number;
}

export function SuppliersHeader({
  pageContent,
  amountOfSuppliers,
}: SuppliersHeaderProps): ReactElement {
  const router = useRouter();
  const isDark = useIsDarkTheme();
  const { ingress, mainHeader } = pageContent.suppliersComponentData.text;

  const processedIngress = ingress.replaceAll(
    /{count}/gi,
    amountOfSuppliers.toString()
  );
  const processedMainHeader = mainHeader.replaceAll(
    /{count}/gi,
    amountOfSuppliers.toString()
  );

  const handleEnquireClick = () => {
    trackEvent(ENQUIRY_BUTTON_CLICKED, {
      source: 'seo',
      destinationUrl: `${getAbsoluteUrl(PATHS.enquiryForm)}`,
      currentPage: getAbsoluteUrl(router.asPath),
    });
  };

  return (
    <Container>
      <SuppliersTitle
        as="h2"
        style="headingExtraLarge"
        color={isDark ? 'white' : 'black'}
      >
        {processedMainHeader}
      </SuppliersTitle>

      <Text style="bodyMedium" color={isDark ? 'lightGrey' : 'darkGrey'}>
        {`${processedIngress} To see more, `}
        <EnquireLink
          href={PATHS.enquiryForm}
          onClick={handleEnquireClick}
          isDark={isDark}
        >
          enquire now!
        </EnquireLink>
      </Text>
    </Container>
  );
}
